import { render, staticRenderFns } from "./edit-outairthreshold.vue?vue&type=template&id=21c26f00&"
import script from "./edit-outairthreshold.vue?vue&type=script&lang=ts&"
export * from "./edit-outairthreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports